import memoize from 'lodash.memoize';
import uniqWith from 'lodash.uniqwith';
import Experience from 'model/IExperience';
import { SortableIAccount } from 'modules/experience/providers/SortedHostProvider';
import { getSortedHosts } from 'modules/experience/utils/sortHosts';

export default memoize(
  (experiences: Experience[], language: string): SortableIAccount[] => {
    const hosts = experiences
      .map((experience) => experience._source)
      .reduce(
        (result, experience) =>
          result.concat(
            experience.is_originals ? experience.hosts : experience.account,
          ),
        [],
      );
    const uniqueHosts = uniqWith(
      hosts,
      (hostA, hostB) => hostA.id === hostB.id,
    );

    return getSortedHosts({
      language,
      hosts: uniqueHosts,
    });
  },
);
